import { TApiDataStateSlice } from "@/redux/store.types";

import { WishlistModel } from "./@types/wishlist.model";

export const $WishlistModuleName = "wishlist";

export type TWishlistState = WishlistModel[];

export type TWishlistStateSlice = TApiDataStateSlice<TWishlistState> &
    Record<string, any>;
